export default __webpack_public_path__ + "f553e3e70f12e3a1991bc999a9519e00.png";